export const SET_PROJECT_TRIGGERS_TABLES = 'SET_PROJECT_TRIGGERS_TABLES';

export const setProjectTriggersTables = (triggersTables: any) => ({
  type: SET_PROJECT_TRIGGERS_TABLES,
  data: triggersTables,
});
